import React, { useEffect, useState } from "react";
import {
  Grid,
  Card,
  Typography,
  Box,
  NativeSelect,
  FormControl,
} from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import RunnerSideBreadcrumbs from "../../../../common/RunnerSideBreadcrumbs";
import AppToolBar from "../../../../common/AppToolBar";
import Header from "../../../../common/Header";
import Properties from "../../../../../properties/Properties";
import { FilterSVGIcon } from "../../../../common/SvgIcon";
import ApplicationUtil from "../../../../../utils/ApplicationUtil";
import { getRunnerActiveParticipation } from "../../../../../apis/userService";
import { useSelector } from "react-redux";
import {
  getRunnerDailyProgressDetails,
  getRunnerProgressDetails,
  getRunnerWeeklyEngagement,
  getRunnerWeeklyPercentileRank,
} from "../../../../../apis/graphService";
import PersonalProgressGraph from "../../../../common/Graphs/PersonalProgressGraph";
import BarGraphView from "../../../../common/Graphs/BarGraphView";
import WeeklyProgressChart from "../../../../common/Graphs/WeeklyProgressChart";
import WeeklyEngagementBlocks from "../../../../common/Graphs/WeeklyEngagementBlocks";

function AnalyticsDashboardView(props) {
  const { classes, location  } = props;
  const runnerData = ApplicationUtil.getRunnerDetails();
  const runnerId = runnerData?.runner?.id;
    let listName = localStorage.getItem("headerLinkSelected");

  const userSelectedEvent = useSelector(
    (state) => state.user.userSelectedEvent,
  );
  const currentRunningProgramChallenge = useSelector(
    (state) => state.user.currentRunningProgramChallenge,
  );


  const [dropdownOptionValues, setDropdownOptionValues] = useState([]);
  const [selectedActivity, setSelectedActivity] = useState("");

  const [runnerProgressData, setRunnerProgressData] = useState(null);
  const [runnerDailyProgressData, setRunnerDailyProgressData] = useState([]);

  const [weeklyPercentileRank, setWeeklyPercentileRank] = useState(null);
  const [weeklyEngagement, setWeeklyEngagement] = useState(null);

  useEffect(() => {
    const fetchList = async () => {
      try {


        let entityId = null;
        let scope = "PROGRAM"

        
        let programData = ApplicationUtil.getRunnersProgramDetails()
        
        if(location?.state?.from === "program"){
          entityId = programData ? programData?.id : currentRunningProgramChallenge?.programId 
          scope = "PROGRAM"
        }else{
          entityId = userSelectedEvent?.id
          scope = "EVENT"
        }

        
        const { data } = await getRunnerActiveParticipation(runnerId , entityId , scope);

        const participationList = data?.activeParticipations || [];
        setDropdownOptionValues(participationList);

        if (participationList.length > 0) {
          const targetId =
            location?.state?.from === "program"
              ? currentRunningProgramChallenge?.id || null
              : userSelectedEvent?.id || null;

          const foundEvent = targetId
            ? participationList.find((event) => event.id === targetId)
            : null;

          if (foundEvent) {
            setSelectedActivity(foundEvent?.id);
          } else {
            setSelectedActivity(participationList[0]?.id || "");
          }
        }
      } catch (error) {
        console.error("Error fetching active participation:", error);
      }
    };
    if (runnerId) {
      fetchList();
    }
  }, [runnerId, userSelectedEvent]); // Added userSelectedEvent to dependency

  // Updated useEffect to handle dynamic Type
  useEffect(() => {
    // 1. Safety Check
    if (!selectedActivity || !runnerId) return;

    let isMounted = true;

    const fetchRunnerProgress = async () => {
      try {
        const selectedOption = dropdownOptionValues.find(
          (option) => option.id == selectedActivity,
        );
        const activityType = selectedOption?.type || "EVENT";

        // --- PARALLEL EXECUTION (Fault Tolerant) ---
        // This waits for ALL requests to finish, regardless of success or failure.
        const results = await Promise.allSettled([
          getRunnerProgressDetails(selectedActivity, runnerId, activityType),
          getRunnerDailyProgressDetails(
            selectedActivity,
            runnerId,
            activityType,
          ),
          getRunnerWeeklyPercentileRank(
            selectedActivity,
            runnerId,
            activityType,
          ),
          getRunnerWeeklyEngagement(selectedActivity, runnerId, activityType),
        ]);

        // --- PROCESS RESULTS ---
        // Destructure results by index (matches the order of the array above)
        const [
          progressResult,
          dailyResult,
          percentileResult,
          engagementResult,
        ] = results;

        if (isMounted) {
          // 1. Runner Progress Data
          if (progressResult.status === "fulfilled") {
            setRunnerProgressData(progressResult.value.data);
          } else {
            console.error(
              "Failed to fetch Runner Progress:",
              progressResult.reason,
            );
            setRunnerProgressData(null);
          }

          // 2. Daily Progress Data
          if (dailyResult.status === "fulfilled") {
            setRunnerDailyProgressData(dailyResult.value.data);
          } else {
            console.error(
              "Failed to fetch Daily Progress:",
              dailyResult.reason,
            );
            setRunnerDailyProgressData([]);
          }

          // 3. Weekly Percentile Data
          if (percentileResult.status === "fulfilled") {
            setWeeklyPercentileRank(percentileResult.value.data);
          } else {
            console.error(
              "Failed to fetch Percentile Rank:",
              percentileResult.reason,
            );
            setWeeklyPercentileRank(null);
          }

          // 4. Weekly Engagement Data
          if (engagementResult.status === "fulfilled") {
            setWeeklyEngagement(engagementResult.value.data);
          } else {
            console.error(
              "Failed to fetch Weekly Engagement:",
              engagementResult.reason,
            );
            setWeeklyEngagement(null);
          }
        }
      } catch (error) {
        console.error("Unexpected error in fetch sequence:", error);
      }
    };

    fetchRunnerProgress();

    return () => {
      isMounted = false;
    };
  }, [selectedActivity, runnerId, dropdownOptionValues]);

  const handleChange = (event) => {
    const newActivity = event.target.value;
    setSelectedActivity(newActivity);
  };

  return (
    <>
      <div className={classes.mainContainer}>
        <AppToolBar
          backNavigate={() => props.history.push("/eventDetails")}
          showBack={true}
        >
          <Header {...props} label={Properties.Label_Individual_Dashboard} />
        </AppToolBar>

        <RunnerSideBreadcrumbs />

        <div>
          <Grid container spacing={2} className={classes.dropdownStyling}>
            <Grid>
              <Typography variant="subtitle2" gutterBottom>
                Track engagement, retention, and performance metrics
              </Typography>
            </Grid>

            <Grid
              component="span"
              style={{ display: "inline-flex", alignItems: "center" }}
            >
              <FilterSVGIcon
                style={{
                  color: "#09456C",
                  fontSize: 18,
                  paddingRight: 5,
                }}
              />
              <FormControl className={classes.formControl}>
                <NativeSelect
                  className={classes.selectActivity}
                  value={selectedActivity}
                  onChange={handleChange}
                  inputProps={{
                    name: "activity",
                    id: "activity-native-simple",
                  }}
                >
                  {dropdownOptionValues.map((value) => (
                    <option key={value.id} value={value.id}>
                      {value.name}
                    </option>
                  ))}
                </NativeSelect>
              </FormControl>
            </Grid>
          </Grid>

          {/* Placeholder sections for charts */}
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Card className={classes.dashboardSection}>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  color="textSecondary"
                  style={{ fontWeight: "bold" }}
                >
                  Personal Progress
                </Typography>
                <Box
                  height={300}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  color="text.secondary"
                  position="relative"
                >
                  <Box
                    width="100%"
                    maxWidth={300}
                    height={300}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    position="relative"
                    zIndex={2}
                  >
                    <PersonalProgressGraph data={runnerProgressData} />
                  </Box>
                </Box>
              </Card>
            </Grid>

            <Grid item xs={12} md={8}>
              <Card className={classes.dashboardSection}>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  color="textSecondary"
                  style={{ fontWeight: "bold" }}
                >
                  {runnerProgressData?.activityType === "DISTANCE"
                    ? "Total Distance (KM)"
                    : runnerProgressData?.activityType === "PROGRAM_CHALLENGE"
                      ? "Total Points"
                      : "Total Steps"}
                </Typography>
                <Box
                  height={300}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  color="text.secondary"
                >
                  <BarGraphView
                    data={runnerDailyProgressData}
                    challengeParameters={runnerProgressData?.activityType}
                  />
                </Box>
              </Card>
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Card className={classes.dashboardSection}>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  color="textSecondary"
                  style={{ fontWeight: "bold" }}
                >
                  Weekwise Engagement
                </Typography>
                <Box
                  height={300}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  color="text.secondary"
                >
                  {/* Charts */}
                  <WeeklyEngagementBlocks data={weeklyEngagement} />
                </Box>
              </Card>
            </Grid>

            <Grid item xs={12} md={8}>
              <Card className={classes.dashboardSection}>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  color="textSecondary"
                  style={{ fontWeight: "bold" }}
                >
                  Percentile Rank
                </Typography>
                <Box
                  height={300}
                  display="flex"
                  flexDirection="column"
                  color="text.secondary"
                >
                  {/* Charts */}
                  <WeeklyProgressChart data={weeklyPercentileRank} />
                </Box>
              </Card>
            </Grid>
          </Grid>
        </div>
      </div>
    </>
  );
}

const styles = (theme) => ({
  mainContainer: {
    marginTop: "68px",
    width: "90%",
    margin: "auto",
  },
  formControl: {
    marginRight: theme.spacing(2),
  },
  selectActivity: {
    textAlign: "center",
    color: "#727272",
    fontSize: 18,
  },
  dropdownStyling: {
    padding: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },

  dashboardSection: {
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1.5),
    border: `1px solid ${theme.palette.divider}`,
    minHeight: 350,
  },
});

export default compose(
  withStyles(styles, { withTheme: true }),
  withRouter,
)(AnalyticsDashboardView);
